import type { MenuItem } from '@/consts/navigation';

interface NavMenuIconProps {
  item: MenuItem;
}

export const NavMenuIcon = ({ item }: NavMenuIconProps) => {
  if (!('icon' in item)) return null;

  return (
    <span className="flex-shrink-0" aria-hidden="true">
      {item.icon}
    </span>
  );
};
